import { ThemeAction } from './types';
import { SET_THEME } from './constants';

export const setTheme = (payload: string): ThemeAction => {
  return {
    type: SET_THEME,
    payload,
  };
};
